// JobOpeningsRoutes.jsx
import { Routes, Route, Outlet } from 'react-router-dom';
import JobOpeningsPage from './../pages/JobOpenings/index';
import Create from './../pages/JobOpenings/create';
import EditJobOpening from './../pages/JobOpenings/edit';

function JobOpeningsLayout() {
  return (
      <Outlet />
  );
}

export default function JobOpeningsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<JobOpeningsLayout />}>
        <Route index element={<JobOpeningsPage />} />        {/* /job-openings */}
        <Route path="create" element={<Create />} />
        <Route path="edit/:id" element={<EditJobOpening />} />
        {/* <Route path="update/:id" element={<JobOpeningsUpdate />} /> */}
      </Route>
    </Routes>
  );
}